import LangEnum from '../../../../../lang/LangEnum';
import { TranslateType } from '../../../../translation/translationContext.types';

export const MAX_FILES_SIZE = 10;
export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
export const MESSAGE_IMAGE_OR_VIDEO_ACCEPTED_TYPES = [
  '.mov',
  'quicktime', // <- .mov
  '.mp4',
  '.webm',
  '.jpg',
  '.jpeg',
  '.png',
  '.gif',
  '.ico',
  '.svg',
  '.webp',
  '.raw',
];
export const ALLOWED_MESSAGE_MIME_TYPES = [
  ...MESSAGE_IMAGE_OR_VIDEO_ACCEPTED_TYPES,
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx',
  'ms-powerpoint', // <- .ppt
  '.pdf',
  '.odt',
  '.ods',
  '.odp',
  '.rtf',
  '.csv',
  '.json',
  '.xml',
  '.html',
  '.zip',
  // tiff, avi e wmv são extensões de image/video, mas estão aqui pois o browser não suporta abrir, então trataremos como arquivos
  '.avi',
  'x-msvideo', // <- .avi
  '.tiff',
  '.wmv',
];

export const validateFileAndGetErrorMessage = (file: File, translate: TranslateType) => {
  const fileName = file.name;

  if (file.size > MAX_FILE_SIZE) {
    return translate(LangEnum.CHAT_MAX_FILE_SIZE, { fileName });
  }
  const allowedTypesToValidation = ALLOWED_MESSAGE_MIME_TYPES.map((type) => type.replace('.', ''));

  if (!allowedTypesToValidation.some((fileType) => file.type.includes(fileType))) {
    return translate(LangEnum.CHAT_ERROR_FILE_TYPE, { fileName });
  }

  return undefined;
};
